import type { EndUser } from "./euscp/euscp"
import EUSignLibraryAdapter from "./EUSignLibraryAdapter"

export default class EUSignLibrary {
    static library: EUSignLibraryAdapter;
    static initializeError?: Error;

    constructor(library?: EndUser, error?: Error) {
        if (library) {
            EUSignLibrary.library = new EUSignLibraryAdapter(library);
        }

        if (error) {
            EUSignLibrary.initializeError = error;
        }
    }

    static getInstance(): EUSignLibraryAdapter {
        return EUSignLibrary.library;
    }

    hasError(): boolean {
        return !!EUSignLibrary.initializeError;
    }
}
